import { Flex, Text } from '@chakra-ui/react'
import { EPaymentStatus } from '@prisma/client'
import { useMemo } from 'react'
import { RiCheckLine, RiCloseLine, RiTimeLine } from 'react-icons/ri'

interface Props {
  status: EPaymentStatus
}

export const PaymentStatus: React.FC<Props> = ({ status }) => {
  const icon = useMemo(() => {
    const strokeWidth = 0
    if (status === 'CANCELLED') {
      return <RiCloseLine strokeWidth={strokeWidth} />
    }
    if (status === 'PROCESSING' || status === 'CONFIRMED') {
      return <RiTimeLine strokeWidth={strokeWidth} />
    }
    if (status === 'SUCCESS') {
      return <RiCheckLine strokeWidth={strokeWidth} />
    }
    return null
  }, [status])

  const text = useMemo(() => {
    if (status === 'CANCELLED') {
      return 'Cancelled'
    }
    if (status === 'PROCESSING') {
      return 'Processing'
    }
    if (status === 'CONFIRMED') {
      return 'Confrimed'
    }
    if (status === 'SUCCESS') {
      return 'Success'
    }
    return ''
  }, [status])

  const color = useMemo(() => {
    if (status === 'CANCELLED') {
      return '#ED5647'
    }
    if (status === 'PROCESSING' || status === 'CONFIRMED') {
      return '#676767888'
    }
    if (status === 'SUCCESS') {
      return '#006838'
    }
    return undefined
  }, [status])

  return (
    <Flex
      fontSize='1rem'
      fontWeight={600}
      gap='.25rem'
      alignItems='center'
      color={color}
    >
      {icon}
      <Text fontSize='.75rem' fontWeight={600}>
        {text}
      </Text>
    </Flex>
  )
}
